export enum LayerType {
  base,
  poles,
  scan,
  tree_type,
  lines,
  encroachment,
  segmentation,
  tree_species,
  wildfire_risk,
  worktype_analysis,
  red_flag_warning,
  distance_bucket,
  overhang,
  trees,
  critical_trees,
  satellite_metadata,
  satellite_metadata_sub,
  fuel_hazard,
  work_status,
}

export const CLICKABLE_LAYERS = [
  LayerType[LayerType.tree_species],
  LayerType[LayerType.tree_type],
  LayerType[LayerType.distance_bucket],
  LayerType[LayerType.encroachment],
  LayerType[LayerType.overhang],
  LayerType[LayerType.satellite_metadata],
  LayerType[LayerType.satellite_metadata_sub],
  LayerType[LayerType.red_flag_warning],
];
export const TREE_COVER_LAYERS = [
  LayerType.segmentation,
  LayerType.encroachment,
  LayerType.tree_type,
  LayerType.tree_species,
];

export interface LayerConfig {
  visible: boolean;
}

export interface EncroachmentLayerConfig extends LayerConfig {
  showOverhang: boolean;
}

export interface RiskTypeConfig extends LayerConfig {
  showHazardTrees: boolean;
  showDecliningTrees: boolean;
  showStrikeTrees: boolean;
  isHazardTreesOnly: boolean;
  showHeatmap: boolean;
}

export interface BaseMapLayerConfig extends LayerConfig {
  darkMode: boolean;
  showLabels: boolean;
}

export interface EncroachmentDetails {
  horizontalDistanceToLine: number;
  verticalDistanceToLine: number;
}

export const DEFAULT_TREE_COVER_MIN_ZOOM = 15.5; // Tree cover zoom

export type LayerConfigMap = Record<
  LayerType,
  LayerConfig | EncroachmentLayerConfig | RiskTypeConfig | BaseMapLayerConfig
>;

export const DEFAULT_MAP_LAYER_CONFIG: LayerConfigMap = {
  [LayerType.base]: {
    visible: true,
    darkMode: false,
    showLabels: true,
  } as BaseMapLayerConfig,
  [LayerType.poles]: { visible: true },
  [LayerType.scan]: { visible: true },
  [LayerType.tree_type]: { visible: false },
  [LayerType.lines]: { visible: true },
  [LayerType.encroachment]: {
    visible: true,
    showOverhang: false,
  } as EncroachmentLayerConfig,
  [LayerType.segmentation]: { visible: false },
  [LayerType.tree_species]: { visible: false },
  [LayerType.wildfire_risk]: { visible: false },
  [LayerType.worktype_analysis]: { visible: false },
  [LayerType.red_flag_warning]: { visible: true },
  [LayerType.distance_bucket]: { visible: true },
  [LayerType.overhang]: { visible: false },
  [LayerType.trees]: {
    visible: true,
    showDecliningTrees: false,
    showHazardTrees: false,
    showStrikeTrees: false,
    isHazardTreesOnly: true,
    showHeatmap: false,
  } as RiskTypeConfig,
  [LayerType.critical_trees]: { visible: false },
  [LayerType.satellite_metadata]: { visible: true },
  [LayerType.satellite_metadata_sub]: { visible: false },
  [LayerType.fuel_hazard]: { visible: false },
  [LayerType.work_status]: { visible: true },
};

export type TreesAggregateData = {
  counts: {
    totalCount: number;
    decliningCount: number;
    hazardCount: number;
    strikeCount: number;
  };
  bounds: number[][];
};
